import { Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
import { registerSchema } from 'utils/validate';
import { yupResolver } from '@hookform/resolvers/yup';
import { InputPassword } from 'app/components/elements/InputPassword';

export type FormSignUpType = {
  password: string;
  confirmPassword: string;
};

type FormSignUpProps = {
  onSubmit: (data: FormSignUpType) => void;
};
export const FormSignUp = ({ onSubmit }: FormSignUpProps) => {
  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm<FormSignUpType>({ resolver: yupResolver(registerSchema) });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack gap={2.5}>
        <InputPassword
          inputProps={register('password')}
          inputError={errors.password?.message}
          placeholder="Password"
        />
        <InputPassword
          inputProps={register('confirmPassword')}
          inputError={errors.confirmPassword?.message}
          placeholder="Confirm Password"
        />
        <ButtonCustom type={'submit'} label={'Sign Up'} />
      </Stack>
    </form>
  );
};
